import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import { PERMISSIONS, useUser } from "./core/context/UserContext";
import { SearchProvider } from "./core/context/SearchContext";
import MainLayout from "./core/components/layout/main-layout/MainLayout";
import DashboardApp from "./app/dashboard/DashboardApp";
import LoginApp from "./app/auth/LoginApp";
import CalendarApp from "./app/appointment/calendar/CalendarApp";
import PatientGridApp from "./app/patient/data-grid/PatientGridApp";
import UnitList from "./app/unit/UnitList";
import UnitCreateEdit from "./app/unit/UnitCreateEdit";
import OperationList from "./app/operation/OperationList";
import OperationCreateEdit from "./app/operation/OperationCreateEdit";
import PriceUpdate from "./app/operation/PriceUpdate";
import DoctorList from "./app/doctor/DoctorList";
import DoctorCreateEdit from "./app/doctor/DoctorCreateEdit";
import InstitutionList from "./app/institution/InstitutionList";
import RoleList from "./app/role/RoleList";
import RoleCreateEdit from "./app/role/RoleCreateEdit";
import UserList from "./app/user/UserList";
import UserCreateEdit from "./app/user/UserCreateEdit";
import CashViewApp from "./app/cash-view/CashViewApp";
import ExpenseCreateEdit from "./app/expense/ExpenseCreateEdit";
import ExpenseGridApp from "./app/expense/data-grid/ExpenseGridApp";
import AppLogDataGridApp from "./app/app-log/datagrid/AppLogDataGridApp";
import SmsLogApp from "./app/sms-log/SmsLogApp";
import FirmPosDeviceApp from "./app/firm-pos-device/FirmPosDeviceApp";
import PatientApp from "./app/appointment/PatientApp";
import CashRegisterCreateEdit from "./app/cash-register/CashRegisterCreateEdit";
import CashRegisterList from "./app/cash-register/CashRegisterList";
import AppointmentDataGridApp from "./app/appointment/appointment-datagrid/AppointmentDataGridApp";
import AppointmentEntitlementConfirmApp from "./app/appointment/appointment-entitlement/AppointmentEntitlementConfirmApp";
import { useEffect } from "react";
import ReminderCreateEdit from "./app/patient/patient-reminder/ReminderCreateEdit"
import AppointmentReminder from "./app/patient/patient-reminder/AppointmentReminder"
import PatientBillingAddressCreateEdit from "./app/patient/patient-billing-address/PatientBillingAddressCreateEdit"
import PatientBillingAddress from "./app/patient/patient-billing-address/PatientBillingAddress"
import PatientQueueGridApp from "./app/appointment/appointment-patient-queue/PatientQueueGridApp"
import EnabizOperationApp from "./app/enabiz-operation/EnabizOperationApp";
import NotificationSettingsApp from "./app/notification-settings/NotificationSettingsApp";

function PrivateRoute({ children, ...rest }) {
    const {
        isAuth,
        user
    } = useUser();

    return (
        <Route {...rest} render={() => {
            return isAuth()
                ? children
                : <Redirect to={'/app/login'} />
        }} />
    )
}

export default function HisRouter() {
    const { hasPermission, user } = useUser();

    return (
        <>
            <Router>
                {/* SearchProvider Router içinde — useHistory'nin çalışması için. */}
                <SearchProvider>
                <Switch>
                    <Route path={'/app/login'} component={LoginApp} />
                    <PrivateRoute>
                        <Switch>
                            <Route>
                                <MainLayout>
                                    <Switch>
                                        <Route exact path={`/`} component={CalendarApp} />
                                        <Route exact path={`/app/dashboard`} component={DashboardApp} />

                                        {hasPermission(PERMISSIONS.APPOINTMENT_VIEW) && <Route path={`/app/calendar`} component={CalendarApp} />}
                                        {hasPermission(PERMISSIONS.APPOINTMENT_VIEW) && <Route path={`/app/appointments/calendar`} component={CalendarApp} />}
                                        {hasPermission(PERMISSIONS.APPOINTMENT_VIEW) && <Route path={`/app/appointments/grid`} component={AppointmentDataGridApp} />}
                                        {hasPermission(PERMISSIONS.APPOINTMENT_VIEW) && <Route path={`/app/appointments/entitlements/confirm`} component={AppointmentEntitlementConfirmApp} />}

                                        {hasPermission(PERMISSIONS.APPOINTMENT_CREATE_EDIT) && <Route path={`/app/patients/:patientId/appointments/:appointmentId/payments`} component={PatientApp} />}
                                        {<Route path={`/app/patients/:patientId/appointments/:appointmentId`} component={PatientApp} />}
                                        {hasPermission(PERMISSIONS.APPOINTMENT_CREATE_EDIT) && <Route path={`/app/patients/:patientId/appointments`} component={PatientApp} />}
                                        {hasPermission(PERMISSIONS.APPOINTMENT_CREATE_EDIT) && <Route path={`/app/patients/appointments`} component={PatientApp} />}
                                        {hasPermission(PERMISSIONS.APPOINTMENT_VIEW) && <Route path={`/app/patients/grid`} component={PatientGridApp} />}

                                        {hasPermission(PERMISSIONS.FIRM_UNIT_MANAGER) && <Route exact path={`/app/system/units`} component={UnitList} />}
                                        {hasPermission(PERMISSIONS.FIRM_UNIT_MANAGER) && <Route exact path={`/app/system/units/create`} component={UnitCreateEdit} />}
                                        {hasPermission(PERMISSIONS.FIRM_UNIT_MANAGER) && <Route exact path={`/app/system/units/edit/:unitId`} component={UnitCreateEdit} />}
                                        <Route exact path={`/app/system/operations`} component={OperationList} />
                                        {hasPermission(PERMISSIONS.FIRM_OPERATION_MANAGER) && <Route exact path={`/app/system/operations/create`} component={OperationCreateEdit} />}
                                        {hasPermission(PERMISSIONS.FIRM_OPERATION_MANAGER) && <Route exact path={`/app/system/operations/edit/:operationId`} component={OperationCreateEdit} />}
                                        {hasPermission(PERMISSIONS.FIRM_OPERATION_MANAGER) && <Route exact path={`/app/system/operations/price-update`} component={PriceUpdate} />}
                                        {hasPermission(PERMISSIONS.FIRM_DOCTOR_MANAGER) && <Route exact path={`/app/system/doctors`} component={DoctorList} />}
                                        {hasPermission(PERMISSIONS.FIRM_DOCTOR_MANAGER) && <Route exact path={`/app/system/doctors/create`} component={DoctorCreateEdit} />}
                                        {hasPermission(PERMISSIONS.FIRM_DOCTOR_MANAGER) && <Route exact path={`/app/system/doctors/edit/:doctorId`} component={DoctorCreateEdit} />}
                                        <Route exact path={`/app/system/institutions`} component={InstitutionList} />
                                        {hasPermission(PERMISSIONS.FIRM_DOCTOR_MANAGER) && <Route exact path={`/app/system/cash-registers`} component={CashRegisterList} />}
                                        {hasPermission(PERMISSIONS.FIRM_CASH_REGISTER) && <Route exact path={`/app/system/cash-registers/create`} component={CashRegisterCreateEdit} />}
                                        {hasPermission(PERMISSIONS.FIRM_CASH_REGISTER) && <Route exact path={`/app/system/cash-registers/:cashRegisterId/edit`} component={CashRegisterCreateEdit} />}

                                        {hasPermission(PERMISSIONS.FIRM_USER_MANAGER) && <Route exact path={`/app/system/roles`} component={RoleList} />}
                                        {hasPermission(PERMISSIONS.FIRM_USER_MANAGER) && <Route exact path={`/app/system/roles/create`} component={RoleCreateEdit} />}
                                        {hasPermission(PERMISSIONS.FIRM_USER_MANAGER) && <Route exact path={`/app/system/roles/edit/:roleId`} component={RoleCreateEdit} />}

                                        {hasPermission(PERMISSIONS.FIRM_USER_MANAGER) && <Route exact path={`/app/system/users`} component={UserList} />}
                                        {hasPermission(PERMISSIONS.FIRM_USER_MANAGER) && <Route exact path={`/app/system/users/create`} component={UserCreateEdit} />}
                                        {hasPermission(PERMISSIONS.FIRM_USER_MANAGER) && <Route exact path={`/app/system/users/edit/:userId`} component={UserCreateEdit} />}

                                        {hasPermission(PERMISSIONS.FIRM_CASH_REGISTER) && <Route exact path={`/app/system/pos-devices`} component={FirmPosDeviceApp} />}

                                        {hasPermission(PERMISSIONS.CASH_REGISTER_VIEW) && <Route exact path={`/app/cash-view`} component={CashViewApp} />}

                                        {hasPermission(PERMISSIONS.EXPENSE_CREATE_EDIT) && <Route exact path={`/app/expenses/create`} component={ExpenseCreateEdit} />}
                                        {hasPermission(PERMISSIONS.EXPENSE_CREATE_EDIT) && <Route exact path={`/app/expenses/edit/:expenseId`} component={ExpenseCreateEdit} />}
                                        {hasPermission(PERMISSIONS.EXPENSE_VIEW) && <Route exact path={`/app/expenses`} component={ExpenseGridApp} />}
                                        {hasPermission(PERMISSIONS.APPLOG_VIEW) && <Route exact path={`/app/applog/grid`} component={AppLogDataGridApp} />}
                                        {hasPermission(PERMISSIONS.APPLOG_VIEW) && <Route exact path={`/app/sms-logs/grid`} component={SmsLogApp} />}
                                        {hasPermission(PERMISSIONS.ENABIZ_OPERATION_TRACKING) && <Route exact path={`/app/system/enabiz-operations`} component={EnabizOperationApp} />}
                                        {hasPermission(PERMISSIONS.NOTIFICATION_SETTINGS_MANAGER) && <Route exact path={`/app/system/notification-settings`} component={NotificationSettingsApp} />}
                                        {<Route exact path={`/app/patient-queue/grid`} component={PatientQueueGridApp} />}

                                        <Route exact path={`/app/system/reminders`} component={AppointmentReminder} />
                                        <Route exact path={`/app/system/reminders/create`} component={ReminderCreateEdit} />
                                        <Route exact path={`/app/system/reminders/edit`} component={ReminderCreateEdit} />

                                        <Route exact path={`/app/system/billingAddress`} component={PatientBillingAddress} />
                                        <Route exact path={`/app/system/billingAddress/create`} component={PatientBillingAddressCreateEdit} />
                                        <Route exact path={`/app/system/billingAddress/edit`} component={PatientBillingAddressCreateEdit} />
                                    </Switch>
                                </MainLayout>
                            </Route>
                        </Switch>
                    </PrivateRoute>
                </Switch>
                </SearchProvider>
            </Router>
        </>
    )
}
